<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import { convertValue, extractMeta } from '../../utilities/utils';
import MagnetWidget from '../../widgets/Magnet';
import { computed } from 'vue';
import type { PropType } from 'vue';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const magnet = computed(() => props.viewValues.values.find((v) => v.type === 'switch'));

const params = computed(() => ({
  temp: convertValue(magnet.value),
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <MagnetWidget v-bind="params" />
</template>

